import React, { FC } from 'react';

import { Helmet } from 'react-helmet-async';

import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/function';
import config from '@root/config';

interface SeoProps {
  title?: string;
}

const baseTitle = config.VITE_APP_TITLE;

const Seo: FC<SeoProps> = ({ title }) => {
  const metaTitle = pipe(
    O.fromNullable(title),
    O.fold(
      () => baseTitle,
      t => `${baseTitle} - ${t}`,
    ),
  );

  return (
    <Helmet>
      <title>{metaTitle}</title>
    </Helmet>
  );
};

export default Seo;
